export const colors = {
  black: "#000000",
  white: "#ffffff",

  whiteCream: "#F6E8EA",

  primaryDarker: "#131416",
  primary: "#282b30",
  primaryLighter: "#393C41",

  secondaryDarker: "#2F9D98",
  secondary: "#6DD3CE",
  secondaryLighter: "#91DEDA",

  warningDarker: "#EF1A2C",
  warning: "#F45B69",
  warningLighter: "#F57A84",
};

export const borderRadius = {
  small: `${5}px`,
  medium: `${10}px`,
  big: `${15}px`,
};

export const padding = {
  small: `${5}px`,
  medium: `${15}px`,
  big: `${25}px`,
};
